module.exports = __webpack_public_path__ + "static/media/twitch.7d21a543.png";